import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const BusinessInfo = ({ business = {} }) => {
  const {
    name = '',
    avatar = '',
    avatarAlt = '',
    rating = 0,
    reviewCount = 0,
    certificationLevel = '',
    reliabilityScore = 0,
    responseTime = '',
    walkingDistance = '',
    walkingTime = ''
  } = business;

  const getCertificationColor = (level) => {
    switch (level?.toLowerCase()) {
      case 'oro':
        return 'text-yellow-600';
      case 'plata':
        return 'text-gray-500';
      case 'bronce':
        return 'text-orange-600';
      default:
        return 'text-muted-foreground';
    }
  };

  const getCertificationIcon = (level) => {
    switch (level?.toLowerCase()) {
      case 'oro': case'plata': case'bronce':
        return 'Award';
      default:
        return 'Shield';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start space-x-4">
        {/* Business Avatar */}
        <div className="flex-shrink-0">
          <div className="w-16 h-16 bg-muted rounded-lg overflow-hidden">
            {avatar ? (
              <Image
                src={avatar}
                alt={avatarAlt}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-primary text-primary-foreground">
                <Icon name="Store" size={24} />
              </div>
            )}
          </div>
        </div>

        {/* Business Details */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="font-heading font-semibold text-lg text-foreground truncate">
                {name}
              </h3>
              
              {/* Rating and Reviews */}
              <div className="flex items-center space-x-3 mt-1">
                <div className="flex items-center space-x-1">
                  <Icon name="Star" size={16} color="var(--color-warning)" />
                  <span className="font-medium text-sm text-foreground">
                    {rating?.toFixed(1)}
                  </span>
                  <span className="text-sm text-muted-foreground">
                    ({reviewCount} reseñas)
                  </span>
                </div>
              </div>
            </div>

            {/* Certification Badge */}
            {certificationLevel && (
              <div className="flex items-center space-x-1 bg-muted px-3 py-1 rounded-full">
                <Icon 
                  name={getCertificationIcon(certificationLevel)} 
                  size={14} 
                  className={getCertificationColor(certificationLevel)}
                />
                <span className={`text-sm font-medium ${getCertificationColor(certificationLevel)}`}>
                  {certificationLevel}
                </span>
              </div>
            )}
          </div>

          {/* Business Metrics */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
            {/* Reliability Score */}
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} color="var(--color-success)" />
              <div>
                <div className="text-sm font-medium text-foreground">
                  {reliabilityScore}% Confiable
                </div>
                <div className="text-xs text-muted-foreground">
                  Puntuación de fiabilidad
                </div>
              </div>
            </div>

            {/* Response Time */}
            {responseTime && (
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} color="var(--color-accent)" />
                <div>
                  <div className="text-sm font-medium text-foreground">
                    {responseTime}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    Tiempo de respuesta
                  </div>
                </div>
              </div>
            )}

            {/* Walking Distance */}
            {walkingDistance && (
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} color="var(--color-primary)" />
                <div>
                  <div className="text-sm font-medium text-foreground">
                    {walkingDistance}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {walkingTime} caminando
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInfo;